import { Box, Typography, ButtonBase } from "@mui/material";
import moment from "moment";
import React from "react";
import treffas from "src/theme/treffas";

const { colors, typography, radius } = treffas;

const timeFormat = (date, userTimeFormat) => {
  return moment(date, userTimeFormat).format(userTimeFormat);
};

const RenderTimeSlots = ({
  selectedSessionTime,
  time,
  handleSelectedTime,
  userTimeFormat,
  customStyle,
}) => {
  return (
    <ButtonBase
      data-testid="public-booking-time-slot"
      sx={{
        width: "100%",
        border: `1px solid ${colors.border.strong}`,
        borderRadius: radius.md,
        height: "42px",
        backgroundColor: colors.background.default,
        color: `${customStyle?.accentColor ?? colors.text.strong} !important`,
        ...(selectedSessionTime?.start === time.start && {
          backgroundColor: `${
            customStyle?.accentColor ?? colors.brand.primary
          } !important`,
          border: "1px solid",
          color: `${
            customStyle?.buttonTextColor ?? colors.text.inverse
          } !important`,
          borderColor: `${
            customStyle?.accentColor ?? colors.brand.primary
          } !important`,
        }),
        "&:hover": {
          backgroundColor: `${
            customStyle?.accentColor ?? colors.brand.primary
          } !important`,
          border: "1px solid",
          borderColor: `${
            customStyle?.accentColor ?? colors.brand.primary
          } !important`,
          color: `${
            customStyle?.buttonTextColor ?? colors.text.inverse
          } !important`,
        },
      }}
      onClick={() => handleSelectedTime(time)}
    >
      <Box>
        <Typography
          sx={{
            fontSize: typography.fontSize.md,
            lineHeight: "18px",
            textAlign: "center",
            letterSpacing: "0.03em",
            color:
              selectedSessionTime?.start === time.start
                ? `${
                    customStyle?.buttonTextColor ?? colors.text.inverse
                  } !important`
                : "inherit",
            fontFamily: customStyle?.bodyFont
              ? `var(--font-${customStyle.bodyFont})`
              : typography.fontFamily.body,
          }}
        >
          {timeFormat(new Date(time.start), userTimeFormat)}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

export default RenderTimeSlots;
